import React from 'react';

import { RichTextComponentFragment } from '../../../../graphql.schema';
import { ContentBlock } from '../../ContentBlock/ContentBlock';

import * as styles from './index.module.scss';

export const StrapiRichTextComponent: React.FC<RichTextComponentFragment> = (props) => {
  return (
    <div className={styles.wrapper}>
      <ContentBlock className={styles.richText} isFluid content={props.content} button={props.button ?? undefined} __typename={props.__typename} />
    </div>
  );
};
